import { Users, Phone, CheckCircle, AlertCircle } from 'lucide-react';

export default function DashboardStats({ leads }) {
  const stats = [
    { id: 'total-leads', label: 'Total leads', value: leads.length, icon: Users },
    { id: 'nouveaux', label: 'Nouveaux', value: leads.filter(l => l.status === 'new').length, icon: AlertCircle },
    { id: 'contactes', label: 'Contactés', value: leads.filter(l => l.status === 'contacted').length, icon: Phone },
    { id: 'convertis', label: 'Convertis', value: leads.filter(l => l.status === 'converted').length, icon: CheckCircle },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      {stats.map(({ id, label, value, icon: Icon }) => (
        <div key={id} className="border border-gray-200 bg-white p-5" data-testid={`stat-${id}`}>
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-bold uppercase tracking-wider text-gray-500 font-['IBM_Plex_Sans']">{label}</span>
            <Icon size={16} className="text-gray-400" />
          </div>
          <p className="font-['Chivo'] font-black text-3xl text-[#111827]">{value}</p>
        </div>
      ))}
    </div>
  );
}
